import { Typography, TypographyProps } from '@material-ui/core';
import React from 'react';
import { css } from 'styled-components/macro';

type Props = {
  large?: boolean;
  centered?: boolean;
  withNext?: boolean;
} & TypographyProps<'h2'>;

export default function Subheading({
  large,
  centered = true,
  withNext = false,
  ...props
}: Props): JSX.Element {
  return (
    <Typography
      variant={large ? 'h5' : 'h6'}
      css={css`
        text-align: ${centered ? 'center' : 'start'};
        ${withNext &&
        css`
          margin-bottom: 0;
        `}
      `}
      {...props}
    />
  );
}
